import { render, staticRenderFns } from "./x-upload-dialog.vue?vue&type=template&id=3f3e9f1e"
import script from "./x-upload-dialog.vue?vue&type=script&lang=js"
export * from "./x-upload-dialog.vue?vue&type=script&lang=js"
import style0 from "./x-upload-dialog.vue?vue&type=style&index=0&id=3f3e9f1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports